import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';

import useTranslation from '@/utils/hooks/translation/useTranslation';

// Lib
import useRouterQuery from '@/utils/hooks/utils/useRouterQuery';

import PropTypes from 'prop-types';

import Checkbox from '@/components/base/Checkbox';
// Components
import Label from '@/components/base/Label';
import FilterSectionTitle from '@/components/pages/myprofile/filters/FilterSectionTitle';

const FilterCollaborators = ({ resetFilters, stopResetFilters, setRequestParams }) => {
    const router = useRouter();
    const { collaboration } = router.query;
    const { deleteQuery } = useRouterQuery();

    const { t } = useTranslation('commons');
    const [activeType, setActiveType] = useState(collaboration ?? false);

    useEffect(() => {
        if (collaboration) {
            const newUrl = deleteQuery(['collaboration']);
            router.replace(newUrl);
        }
    }, [collaboration]);

    useEffect(() => {
        setRequestParams((prevState) => {
            return {
                ...prevState,
                collaboration: activeType ?? undefined
            };
        });
    }, [activeType, setRequestParams]);

    useEffect(() => {
        if (resetFilters) {
            setActiveType(false);
            stopResetFilters();
        }
    }, [resetFilters]);

    return (
        <div>
            <FilterSectionTitle icon="multiprofiles">
                {t('myprofile:collaboration.title')}
            </FilterSectionTitle>
            <Label fontType={'checkboxList'} className="relative cursor-pointer pl-7">
                <Checkbox
                    onChange={() => setActiveType(!activeType)}
                    checked={activeType}
                    value={activeType}
                    className="absolute left-0 top-0"
                />
                <span className="align-middle">{t('myprofile:collaboration.label')}</span>
            </Label>
        </div>
    );
};

FilterCollaborators.propTypes = {
    resetFilters: PropTypes.bool,
    stopResetFilters: PropTypes.func,
    setRequestParams: PropTypes.func.isRequired
};

export default FilterCollaborators;
